import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

export const getCustomChargeRecord = async (transactionId: string) => {
  const response = await queryExecute({
    fetchPolicy: 'no-cache',
    variables: {
      id: transactionId,
    },
    query: graphql(`
      query GetCustomChargeRecord($id: String!) {
        getCustomChargeRecord(id: $id) {
          id
          associatedObjectId
          associatedObjectType
          description
          notes
          customerName
          customerCost
          customerRefund
          customerChargeId
          customerRefundId
          customerCredits
          customerCreditsRefund
          partnerName
          partnerCost
          partnerRefund
          partnerChargeId
          partnerRefundId
          partnerCredits
          partnerCreditsRefund
        }
      }
    `),
  });

  return response.data.getCustomChargeRecord;
};
